import { gql } from '@apollo/client';

export const HELP_CENTER_FEEDBACK = gql`
  mutation helpCenterFeedback($slug: String!, $rating: String!) {
    helpCenterFeedback(slug: $slug, rating: $rating) {
      success
      message
    }
  }
`;
